import TipTapEditor from '@/components/TipTapEditor' 


export default (Vue)=>{
  Vue.component("TipTapEditor", TipTapEditor ) 
}